// @flow
import {
  GetEmployeeDetails,
  GetEmployeeDetailsSuccess,
  GetEmployeeDetailsError,
  GetEmployeeRiskSummary,
  GetEmployeeRiskSummarySuccess,
  GetEmployeeRiskSummaryError,
  GetAbsenceDurationsSummary,
  GetAbsenceDurationsSummarySuccess,
  GetAbsenceDurationsSummaryError,
} from "@modules/reporting/constants/actions";
import type { EmployeeDetailsState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: EmployeeDetailsState = {
  error: null,
  requestsInProgress: 0,
  details: null,
  employeeRiskSummary: [],
  riskTimeline: [],
  absenceDurationSummary: [],
};

export const setLoading = (state: EmployeeDetailsState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetEmployeeDetailsSuccess = (state: EmployeeDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    details: payload,
  };
};

export const onGetEmployeeDetailsError = (state: EmployeeDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};
export const onGetAbsenceDurationsSummarySuccess = (state: EmployeeDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    absenceDurationSummary: payload,
    error: null,
  };
};

export const onGetAbsenceDurationsSummaryError = (state: EmployeeDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onGetEmployeeRiskSummarySuccess = (state: EmployeeDetailsState) => ({
  payload,
}: Object) => {
  return { ...state, ...payload, requestsInProgress: --state.requestsInProgress };
};

export const onGetEmployeeRiskSummaryError = (state: EmployeeDetailsState) => ({
  payload,
}: Object) => {
  return { ...state, error: payload, requestsInProgress: --state.requestsInProgress };
};

export default (
  state: EmployeeDetailsState = initialState,
  action: Object,
): EmployeeDetailsState => {
  let act = {
    [GetEmployeeRiskSummary]: setLoading,
    [GetEmployeeDetailsSuccess]: onGetEmployeeDetailsSuccess,
    [GetEmployeeDetailsError]: onGetEmployeeDetailsError,

    [GetAbsenceDurationsSummary]: setLoading,
    [GetAbsenceDurationsSummarySuccess]: onGetAbsenceDurationsSummarySuccess,
    [GetAbsenceDurationsSummaryError]: onGetAbsenceDurationsSummaryError,

    [GetEmployeeDetails]: setLoading,
    [GetEmployeeRiskSummarySuccess]: onGetEmployeeRiskSummarySuccess,
    [GetEmployeeRiskSummaryError]: onGetEmployeeRiskSummaryError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
